import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemIndexSetsTypes } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  options: [],
  currentTypes: {}
};
const fetchIndexSetFieldTypesAll = async (indexSetId) => SystemIndexSetsTypes.indexSetFieldTypesListByindex_set_idAndfieldNameQueryAndfiltersAndsortAndorder(
  void 0,
  indexSetId
).then((elements) => ({
  currentTypes: Object.fromEntries(
    elements.map((fieldType) => [fieldType.field_name, fieldType.type])
  ),
  options: elements.map((fieldType) => ({
    value: fieldType.field_name,
    label: fieldType.field_name,
    disabled: fieldType.is_reserved === true
  }))
}));
const useIndexSetFieldTypesAll = (indexSetId) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["indexSetFieldTypesAll", indexSetId],
    queryFn: () => defaultOnError(
      fetchIndexSetFieldTypesAll(indexSetId),
      "Loading index field types failed with status",
      "Could not load index field types"
    ),
    placeholderData: keepPreviousData,
    enabled: !!indexSetId
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useIndexSetFieldTypesAll;
